(() => {
  const key = 'sekacamp:recent-products:v1';
  let history = [];
  try { history = JSON.parse(sessionStorage.getItem(key) || '[]').filter(x => typeof x === 'string' && /^[a-z0-9%._~-]+$/i.test(x)).slice(0,12); } catch (_) {}
  const current = document.querySelector('[data-current-product]')?.dataset.currentProduct;
  if (current) { try { sessionStorage.setItem(key, JSON.stringify([encodeURIComponent(current), ...history.filter(x => x !== encodeURIComponent(current))].slice(0,12))); } catch (_) {} }
  class RecentProducts extends HTMLElement {
    connectedCallback() {
      if (this.started) return; this.started = true;
      const handles = history.filter(x => x !== encodeURIComponent(current || '')).slice(0,Number(this.dataset.limit)||4);
      if (!handles.length) return;
      const observer = new IntersectionObserver(entries => { if (entries.some(e => e.isIntersecting)) { observer.disconnect(); this.load(handles); } }, {rootMargin:'400px'});
      this.hidden = false; observer.observe(this); this.observer = observer;
    }
    disconnectedCallback() { this.observer?.disconnect(); this.controller?.abort(); }
    async load(handles) {
      this.controller = new AbortController();
      const cards = await Promise.all(handles.map(async handle => {
        try {
          const root = this.dataset.root.replace(/\/$/,'');
          const response = await fetch(`${root}/products/${handle}?section_id=history-card`, {signal:this.controller.signal});
          if (!response.ok) return null;
          const doc = new DOMParser().parseFromString(await response.text(),'text/html');
          const template = doc.querySelector('template[data-history-card]');
          if (!template?.content.querySelector('a')) return null;
          const li = document.createElement('li'); li.append(template.content.cloneNode(true)); return li;
        } catch (_) { return null; }
      }));
      const usable = cards.filter(Boolean);
      if (!this.isConnected) return;
      this.querySelector('ul').replaceChildren(...usable); this.hidden = !usable.length;
    }
  }
  if (!customElements.get('recent-products')) customElements.define('recent-products',RecentProducts);
})();
